import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { Comment } from '@/models/features/comments.models'
import { getApiErrorMessage, resetQueries } from '@/utils'

import { GET_PENDING_COMMENTS_QUERY_KEY } from './get-pending-comments'
import { GET_POSTS_BY_ID_QUERY_KEY } from './get-post-by-id'

export type ApproveRejectCommentRequest = {
  groupId: number
  postId: number
  commentId: number
  approve: boolean
}

export const approveRejectComment = async ({
  groupId,
  postId,
  commentId,
  approve,
}: ApproveRejectCommentRequest) => {
  const result = await authAPI.post<Comment>(
    `/group/${groupId}/post/${postId}/comment/${commentId}/review`,
    {
      approve,
    },
  )

  return result.data
}

export const useApproveRejectComment = () => {
  return useMutation({
    mutationFn: approveRejectComment,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async (comment) => {
      await resetQueries([GET_PENDING_COMMENTS_QUERY_KEY], [GET_POSTS_BY_ID_QUERY_KEY])
      toastFactory.success(`Comment ${comment.approved ? 'approved' : 'removed'}`)
    },
  })
}
